// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__EfZ-0","addWidgetButton":"Header_addWidgetButton__s7G3p","dashboardTabs":"Header_dashboardTabs__26KPJ","active":"Header_active__2GqIS"};